import React from "react";
import "./Awards.css";

function Awards() {
  return (
    <>
      <div className="sap-awards-wrap"> 
      <div className="sap-awards-row">
          <div className="sap-awards-box">
            <img
              src="/images/awards/SAPTalentTransformation.png"
              alt="awards"
              className="awards-icon-img"
            />
            <img
              src="/images/awards/international-icon.png"
              alt="international-icon"
              className="international-icon"
            />
            <div className="awards-text">
              <h3>
                SAP Talent Transformation
                <br /> <span>2024</span>
              </h3>
              <p>Best Results of a Learning Program</p>
            </div>
          </div>
        </div>       
        <div className="sap-awards-row">
          <div className="sap-awards-box">
            <img
              src="/images/awards/IgnitingGrowth-img-new.png"
              alt="awards"
              className="awards-icon-img"
            />
            <img
              src="/images/awards/international-icon.png"
              alt="international-icon"
              className="international-icon"
            />
            <div className="awards-text">
              <h3>
                SAP Talent Transformation: Igniting Growth and Success at ATCI{" "}
                <br /> <span>2023</span>
              </h3>
              <p>Best Results of a Learning Program</p>
            </div>
          </div>
        </div>
        <div className="sap-awards-row">
          <div className="sap-awards-box">
            <img
              src="/images/awards/SAP-Talent-Transformation-Program.png"
              alt="awards"
              className="awards-icon-img"
            />
            <img
              src="/images/awards/international-icon.png"
              alt="international-icon"
              className="international-icon"
            />
            <div className="awards-text">
              <h3>
                SAP Talent Transformation Program <br /> <span>2022</span>
              </h3>
              <p>Best Unique or Innovative Learning and Development Program</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Awards;
